export const WORDPRESS_PRODUCT_ID = [256, 250, 253, 259];
